import { z } from "zod"
import { Attachment } from "../message/attachment"

export interface SupportChatMessageResponse {
  id: string
  content: string
  isFromAdmin: boolean
  isRead: boolean
  isManuallyUnread: boolean
  senderStoreId: string | null
  createdAt: Date
  attachments: Attachment[]
}

export interface SupportChatThreadResponse {
  id: string
  anchorStoreId: string
  storeName: string
  latestMessage: string | null
  latestMessageDate: Date | null
  unreadCount: number
}

export interface AdminCreateThreadResponse {
  threadId: string
}

export const SendSupportChatMessageSchema = z.object({
  content: z.string().min(1),
})

export type SendSupportChatMessage = z.infer<
  typeof SendSupportChatMessageSchema
>

export const SetSupportChatMessageReadStatusSchema = z.object({
  messageId: z.guid(),
  isRead: z.boolean(),
  isManuallyUnread: z.boolean(),
})

export type SetSupportChatMessageReadStatus = z.infer<
  typeof SetSupportChatMessageReadStatusSchema
>
